export default "__VITE_ASSET__CqRv_qnS__"